// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_532610f4",
      load: () => import("#nuxt-i18n/532610f4" /* webpackChunkName: "locale_en_46js_532610f4" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46js_feed1544",
      load: () => import("#nuxt-i18n/feed1544" /* webpackChunkName: "locale_fr_46js_feed1544" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "fr",
    language: undefined
  }
]

